// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
/**
 * A no-op implementation of HttpTextFormat to be used when tracing is disabled.
 */
var NoOpHttpTextFormat = /** @class */ (function () {
    function NoOpHttpTextFormat() {
    }
    /**
     * Injects the given SpanContext for transmitting to a remote server.
     * @param _spanContext The SpanContext to transmit
     * @param _format The format of the carrier
     * @param _carrier The carrier to propagate through, e.g. an HTTP request
     */
    NoOpHttpTextFormat.prototype.inject = function (_spanContext, _format, _carrier) { };
    /**
     * Returns a SpanContext intance extracted from the carrier.
     * @param _format the format of the carrier
     * @param _carrier The carrier being used for propagation, e.g. an HTTP request
     */
    NoOpHttpTextFormat.prototype.extract = function (_format, _carrier) {
        return null;
    };
    return NoOpHttpTextFormat;
}());
export { NoOpHttpTextFormat };
//# sourceMappingURL=noOpHttpTextFormat.js.map